import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-plan-success-dialog',
  templateUrl: './plan-success-dialog.component.html',
  styleUrls: ['./plan-success-dialog.component.scss']
})
export class PlanSuccessDialogComponent {

  constructor(private dialogRef: MatDialogRef<PlanSuccessDialogComponent>) {}

  close() {
    this.dialogRef.close();
  }
  
  goVendor() {
    this.dialogRef.close('vendor');
  }

  goHome() {
    this.dialogRef.close('home');
  }
}
